import { useEffect, useState } from 'react'

const readMatch = query =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? !!window.matchMedia(query)?.matches
    : false

const useMediaQuery = query => {
  const [matches, setMatches] = useState(() => readMatch(query))

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined
    const mql = window.matchMedia(query)
    if (!mql) return undefined
    const update = () => setMatches(!!mql.matches)
    update()
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', update)
      return () => mql.removeEventListener('change', update)
    }
    if (typeof mql.addListener === 'function') {
      mql.addListener(update)
      return () => mql.removeListener(update)
    }
    return undefined
  }, [query])

  return matches
}

export default useMediaQuery
